// extracted by mini-css-extract-plugin
export default {"navbarSec":"navbar_navbarSec__a0r5j"};